// Configuration for API endpoints
// This file is auto-generated by Render during build
// For local development, point to your backend
// Production: https://nova-bot-back-end.onrender.com
// Local: http://localhost:3000

// Same-origin by default: in dev the Vite proxy forwards /api to the backend (see vite.config.js),
// like every other request (utils/apiBase.js).
export const API_URL = import.meta.env.VITE_API_URL ||
  (typeof window !== 'undefined' && window.NOVA_API_URL) ||
  '/api/rag/answer';

export const HR_EMAIL = 'hr@yourcompany.com';
export const MAX_SUGGESTIONS = 3;
export const MAX_MESSAGE_LENGTH = 10000;
export const TYPING_TIMEOUT = 3000;
export const AUTO_SCROLL_DELAY = 100;
export const WARNING_THRESHOLD = 8000;
export const ERROR_THRESHOLD = 9500;

